

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const fatfreezing: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "fat-freezing",
        "meta": {
            "title": "Fat Freezing  in Dubai | Elite Body Home",
            "description": "Non-invasive fat reduction with cryolipolysis to target and destroy stubborn fat cells for a sculpted look. Safe, effective treatment with no downtime.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/fat-freezing-coolsculpting-dubai/",
            "og": {
                "title": "Fat Freezing  in Dubai | Elite Body Home",
                "description": "Non-invasive fat reduction with cryolipolysis in Dubai",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-48.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Fat Freezing "],
        "hero": {
            "title": "Fat Freezing in Dubai",
            "subtitle": "Non-Invasive Fat Reduction",
            "description": "Fat freezing, scientifically referred to as cryolipolysis, is a non-invasive body contouring treatment intended to remove stubborn pockets of fat. Unlike traditional dietary approaches that lead to disappointing results, this therapy can actually eliminate problem areas, making it an incredibly effective option for those who are looking for non-surgical fat reduction. Our fat freezing treatment at Elite Body Home Polyclinic offers a safe, effective, and painless way for our clients to achieve sculpted and toned looks."
        },
        "howItWorks": {
            "title": "Fat Freezing Treatment — What You Must Know",
            "description": "Cryolipolysis, popularly known as fat freezing treatment, entails assisting the body with fat loss acts by externally targeting fat cells by freezing them with the help of controlled cooling in a way that does not affect the adjacent cells, which are gradually removed by the body. The process is based on the fact that fat cells are more sensitive to cold temperatures than other types of tissue, so they can be selectively eliminated without harming the skin or surrounding muscles."
        },
        "procedureSteps": {
            "heading": "How Does Fat Freezing Work?",
            "para": "Fat freezing cools the targeted areas of fat to a colder temperature that causes the fat cells to crystallize and die. Here's a brief, step-by-step outline of the process:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A professional will assess the treatment areas and create an individualized care plan.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "Application of Cooling Device",
                    "desc": "An applicator is applied to the skin that delivers controlled cooling to the layer of fat beneath the skin.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "Freezing of Fat Cells",
                    "desc": "This cooling stage lasts between 30-60 minutes and freezes the fat cells without causing any pain for the patient.",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "Natural Elimination",
                    "desc": "In the weeks that follow, the dead fat cells are gradually processed and eliminated via the body's lymphatic system.",
                    "icon": "fa-solid fa-recycle"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages of Fat Freezing Therapy",
            "subheading": "There are many advantages of fat freezing for those looking for a non-surgical method of fat reduction",
            "para": "Here are some of its major benefits:",
            "items": [
                {
                    "title": "Non-invasive",
                    "desc": "Requires no incisions, anesthesia, or downtime.",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "Targeted Fat Reduction",
                    "desc": "Successfully treats resistant fat pockets that do not respond to diet and exercise.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Safe and Painless",
                    "desc": "It delivers a gentle cooling effect that does not damage surrounding tissues.",
                    "icon": "fa-solid fa-shield"
                },
                {
                    "title": "Quick & Long-Lasting Results",
                    "desc": "The whole process is quick (15 to 30 minutes), and the results can last 4 to 6 months!",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Permanent Fat Loss",
                    "desc": "Because when fat cells are destroyed, they are gone from the body, permanently.",
                    "icon": "fa-solid fa-infinity"
                }
            ]
        },
        "eligibility": {
            "heading": "Who is Considered a Suitable Candidate for Fat Freezing Procedure?",
            "subheading": "",
            "para": "Fat freezing is great for those who are near their desired body weight, but have trouble spots that will not go away no matter how clean a diet you follow. The ideal patient for this treatment:",
            "items": [
                {
                    "title": "Near Goal Weight",
                    "desc": "Are within 10-20 pounds of their goal weight.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "Set realistic expectations and know that fat freezing is not a weight-loss procedure.",
                    "icon": "fa-solid fa-lightbulb"
                },
                {
                    "title": "Localized Fat Deposits",
                    "desc": "If you have stubborn fat in localized area like belly, thighs, arms or back.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "Health Conditions",
                    "desc": "Are not pregnant or nursing. Do not have cryoglobulinemia or cold agglutinin disease.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "preparationTips": {
            "heading": "What to Do before Fat Freezing Treatment",
            "subheading": "",
            "para": "The better prepared you are, the better results you'll get from your fat freezing session, so keep reading. Here are a few things to do before your appointment:",
            "items": [
                {
                    "title": "Avoid Anti-inflammatory Medications",
                    "desc": "These can disrupt the body's inflammation response, and that's a vital part for getting rid of the fat cells.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Wear Loose Clothing",
                    "desc": "Try to wear loose comfortable clothing: You want to be comfortable during the procedure, and loose-fitting clothing will avoid putting pressure on the treated areas afterward.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Hydrating thoroughly supports recovery and improves the ability of the lymphatic system to flush dead fat cells.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid Tanning",
                    "desc": "Skin that is tanned or sunburned may be more sensitive in the procedure.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Clean Skin",
                    "desc": "The day of your treatment, arrive with a clean face, free of makeup or lotions.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "The optimal results are seen over 2-3 months with a marked loss of fat volume in the treated areas. With hard work dieting and exercising, the results can last a very long time, since fat cells do not regenerate.",
            "items": [
                {
                    "title": "Visible Fat Reduction",
                    "desc": "Noticeable reduction in fat volume in treated areas within 2-3 months.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Permanent Results",
                    "desc": "Destroyed fat cells are permanently eliminated from the body.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Long-Term Maintenance",
                    "desc": "Results can be long-lasting with proper diet and exercise.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "Fat Freezing treatment aftercare is very important to get the best results",
            "para": "Although the procedure is non-invasive and carries few side effects, these aftercare tips can improve both your post-op recovery and your fat reduction process:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water to flush out dead fat cells from your body more effectively. Keeping hydrated is also essential for your health in general and helps you recover faster.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Gentle Exercise",
                    "desc": "Gentle physical activity such as walking or light stretching can help improve circulation and support the lymphatic system, which helps the body remove the damaged fat cells.",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "Avoid Intense Workouts",
                    "desc": "Avoid vigorous workouts (or anything else that might cause discomfort in the treated area) for the first 24 to 48 hours after your session. After this period, you might slowly return to your usual workout routine.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "The areas that were treated may feel slightly sensitive or swollen. To reduce irritation, wear loosefitting, comfortable clothes in the days after your treatment.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Massage the Treated Area",
                    "desc": "Massaging the area that you had treated a couple of times a day for about 5 to 10 minutes can help to break down fat cells as well as keeping circulation, which will help improve your results.",
                    "icon": "fa-solid fa-hands"
                },
                {
                    "title": "Healthy Diet",
                    "desc": "Make sure you are eating well to complement your fat burning results. Be careful with fatty or sugary foods as might impair your progress.",
                    "icon": "fa-solid fa-apple-alt"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How many sessions will I need?",
                    "answer": "Most patients see optimal results with 1-2 sessions per treatment area, spaced a few months apart."
                },
                {
                    "question": "Is fat freezing painful?",
                    "answer": "The procedure is generally well-tolerated. You may feel intense cold initially, but this sensation typically subsides as the area becomes numb."
                },
                {
                    "question": "When will I see results?",
                    "answer": "You may begin seeing results within 3 weeks, with optimal results appearing after 2-3 months as your body naturally eliminates the fat cells."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common temporary side effects include redness, swelling, bruising, numbness or tingling in the treated area, which typically resolve within days or weeks."
                },
                {
                    "question": "Is the fat reduction permanent?",
                    "answer": "Yes, the destroyed fat cells are permanently eliminated. However, maintaining a stable weight is important to prevent remaining fat cells from enlarging."
                },
                {
                    "question": "Who is not a good candidate?",
                    "answer": "Fat freezing is not for obese individuals or those with cryoglobulinemia, cold agglutinin disease, or paroxysmal cold hemoglobinuria."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "البطن",
                "title": "Abdomen (Belly Fat)",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/abdomen-cryo.jpg"
            },
            {
                "ar": "الفخذين",
                "title": "Thighs (Inner & Outer)",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/thighs-cryo.jpg"
            },
            {
                "ar": "الجوانب",
                "title": "Love handles (Flanks)",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/flanks-cryo.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "الظهر",
                "title": "Back (Bra Fat)",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/back-cryo.jpg"
            },
            {
                "ar": "الذراعين",
                "title": "Arms",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/arms-cryo.jpg"
            },
            {
                "ar": "الذقن المزدوج",
                "title": "Double chin",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/chin-cryo.jpg"
            }
        ]
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/New-Service-Banner-Image-9-scaled.jpg",
            "beforeAfter": [
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-3-1.jpg",
                    alt: "weight loss (3)",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-1-1.jpg",
                    alt: "weight loss (1)",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-2-1.jpg",
                    alt: "Ozempic in Dubai",
                },
            ]
        },
        "product": {
            "id": 164,
            "title": "Fat Freezing (Cryolipolysis) in Dubai",
            "description": "Non-invasive fat reduction with cryolipolysis to target and destroy stubborn fat cells for a sculpted look. Safe, effective treatment with no downtime.",
            "price": 999
        }
    },
    "ar": {
        "url": "fat-freezing",
        "meta": {
            "title": "تجميد الدهون (كول سكالبتينج) في دبي | ايليت بودي هوم",
            "description": "علاج غير جراحي لتقليل الدهون باستخدام تقنية الكرايو ليبوليسيس (تجميد الدهون) لاستهداف وتدمير الخلايا الدهنية غير المرغوب فيها للحصول على مظهر أكثر نحتاً. علاج آمن وفعال دون تعافي.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/fat-freezing",
            "og": {
                "title": "تجميد الدهون (كول سكالبتينج) في دبي | ايليت بودي هوم",
                "description": "علاج غير جراحي لتقليل الدهون باستخدام تقنية الكرايو ليبوليسيس في دبي",
                "image": "https://www.elitebodyhome.com/images/fat-freezing-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "تجميد الدهون (كول سكالبتينج)"],
        "hero": {
            "title": "تجميد الدهون (كول سكالبتينج) في دبي",
            "subtitle": "تقليل الدهون غير الجراحي",
            "description": "يُعد تجميد الدهون، أو ما يُعرف علميًا بكرايو ليبوليسس (Cryolipolysis)، علاجًا غير جراحي لنحت الجسم يهدف للتخلص من الجيوب الدهنية العنيدة. هذه التقنية قادرة فعليًا على القضاء على مناطق الدهون العنيدة، مما يجعلها خيارًا فعالًا للغاية لمن يبحث عن تقليل الدهون دون تدخل جراحي، على عكس الأنظمة الغذائية التي قد تؤدي إلى نتائج محبطة. نقدم في عيادات ايليت بودي هوم جلسات تجميد الدهون بطريقة آمنة وفعّالة وخالية من الألم لمساعدتك في الحصول على قوام منحوت ومشدود."
        },
        "howItWorks": {
            "title": "كل ما تحتاج معرفته عن جلسة تجميد الدهون",
            "description": "يُعرف علاج تجميد الدهون باسم كرايو ليبوليسس، وهو إجراء غير جراحي يستهدف الخلايا الدهنية من خلال تبريدها بدرجة حرارة منخفضة ومحسوبة دون التأثير على الأنسجة المحيطة. ومع مرور الوقت، يتخلص الجسم من هذه الخلايا بشكل طبيعي. تعتمد هذه التقنية على حقيقة أن الخلايا الدهنية تتأثر أكثر بالبرودة مقارنة بالخلايا الأخرى، مما يتيح تدمير الخلايا الدهنية دون الإضرار بالبشرة أو العضلات المحيطة."
        },
        "procedureSteps": {
            "heading": "كيف يعمل علاج تجميد الدهون؟",
            "para": "تعتمد تقنية تجميد الدهون على تبريد الخلايا الدهنية في منطقة معينة من الجسم حتى تصل إلى درجة حرارة تؤدي إلى تجمدها وتبلورها وموتها تدريجيًا. إليك خطوات الجلسة:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يقوم الطبيب المتخصص بتقييم المناطق المستهدفة ووضع خطة علاج.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "استخدام جهاز التبريد",
                    "desc": "يُستخدم جهاز التبريد على الجلد، حيث يوفر تبريدًا مضبوطًا بدقة لطبقة الدهون تحت الجلد.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "تجميد الخلايا الدهنية",
                    "desc": "تستغرق هذه المرحلة ما بين 30 إلى 60 دقيقة، ويتم خلالها تجميد الدهون دون أي ألم.",
                    "icon": "fa-solid fa-temperature-low"
                },
                {
                    "title": "التخلص الطبيعي من الخلايا الدهنية",
                    "desc": "يتخلص الجسم من الخلايا الدهنية الميتة خلال الأسابيع التالية للعلاج من خلال الجهاز اللمفاوي.",
                    "icon": "fa-solid fa-recycle"
                }
            ]
        },
        "benefits": {
            "heading": "فواد علاج تجميد الدهون",
            "subheading": "يوفر علاج تجميد الدهون العديد من الفوائد لمن يبحث عن علاج لتقليل الدهون بطريقة غير جراحية",
            "para": "فيما يلي بعض من أبرز مزايا جلسات تجميد الدهون:",
            "items": [
                {
                    "title": "إجراء غير جراحي",
                    "desc": "لا يتطلب أي تدخل جراحي أو تخدير، ولا تحتاج إلى فترة تعافي.",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "استهداف الدهون العنيدة",
                    "desc": "يُعد علاج فعال في التخلص من التراكمات الدهنية التي لا تستجيب للنظام الغذائي أو التمارين الرياضية.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "علاج آمن وخالي من الألم",
                    "desc": "يعتمد العلاج على تبريد لطيف لا يؤثر على الأنسجة المحيطة.",
                    "icon": "fa-solid fa-shield"
                },
                {
                    "title": "نتائج سريعة تدوم طويلًا",
                    "desc": "تستغرق الجلسة ما بين 15 إلى 30 دقيقة فقط، ويمكن ملاحظة النتائج خلال 4 إلى 6 أشهر.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "التخلص من الدهون بشكل دائم",
                    "desc": "يتم التخلص من الخلايا الدهنية نهائيًا من الجسم عند تدميرها بالتبريد، مما يمنح نتائج دائمة.",
                    "icon": "fa-solid fa-infinity"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لعلاج تجميد الدهون؟",
            "subheading": "",
            "para": "يُعتبر علاج تجميد الدهون خيارًا مثاليًا للأشخاص الذين يتقارب وزنهم الحالي من الوزن المرغوب فيه، ولكن يعانون من تراكم الدهون العنيدة التي لا تستجيب للنظام الغذائي في بعض المناطق. المرشحون المثاليون لهذا الإجراء هم:",
            "items": [
                {
                    "title": "قريب من الوزن المثالي",
                    "desc": "الأشخاص الذين يتقارب وزنهم الحالي من الوزن المستهدف بحوالي 10 إلى 20 رطل.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "توقعات واقعية",
                    "desc": "الأشخاص الذين يدركون أن العلاج مخصص لنحت الجسم وليس لإنقاص الوزن.",
                    "icon": "fa-solid fa-lightbulb"
                },
                {
                    "title": "تراكمات دهنية موضعية",
                    "desc": "الأشخاص الذين يعانون من تجمعات دهنية موضعية مثل دهون البطن، أو الفخذين، أو الذراعين، أو الظهر.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "حالات صحية",
                    "desc": "المرأة إذا كانت غير حامل أو مُرضعة. الأشخاص الذين لا يعاني من أمراض مثل مرض وجود الغلوبولينات البردية في الدم أو مرض الراصة الدموية البرودية.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "preparationTips": {
            "heading": "ما يجب فعله قبل جلسة تجميد الدهون",
            "subheading": "",
            "para": "كلما كنت مستعدًا أكثر قبل الجلسة، تمكنت من الحصول على أفضل النتائج من جلسات تجميد الدهون. إليك أهم الإرشادات التي يُنصح باتباعها قبل موعدك:",
            "items": [
                {
                    "title": "تجنب الأدوية المضادة للالتهابات",
                    "desc": "قد تعيق الأدوية المضادة للالتهاب مثل الإيبوبروفين أو الأسبرين عملية الالتهاب الطبيعية، وهي ضرورية لتفكيك الخلايا الدهنية بعد العلاج.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "ارتدِ ملابس مريحة",
                    "desc": "ارتدِ ملابس فضفاضة لضمان راحتك أثناء الجلسة وتجنب الضغط على المناطق التي خضعت للعلاج بعد الانتهاء.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يعزز شرب كميات كافية من الماء من عملية التعافي ويساعد الجهاز اللمفاوي على التخلص من الخلايا الدهنية الميتة بكفاءة.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب جلسات التسمير",
                    "desc": "تكون البشرة المُعرضة للشمس أو التي تعاني من حروق أكثر حساسية أثناء الجلسة.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "احضر ببشرة نظيفة",
                    "desc": "تجنب استخدام أي كريمات أو مستحضرات تجميل على المنطقة المُعالجة في يوم العلاج.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "تبدأ النتائج في الظهور خلال شهرين إلى 3 أشهر بعد الجلسة، حيث تلاحظ انخفاضًا واضحًا في حجم الدهون بالمناطق المعالجة. يمكن أن تدوم النتائج لفترة طويلة بالاستمرار في اتباع نظام غذائي صحي وممارسة الرياضة، لأن الخلايا الدهنية التي يتم التخلص منها لا تعود مرة أخرى.",
            "items": [
                {
                    "title": "انخفاض واضح في الدهون",
                    "desc": "انخفاض ملحوظ في حجم الدهون في المناطق المعالجة خلال 2-3 أشهر.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "نتائج دائمة",
                    "desc": "يتم التخلص من الخلايا الدهنية المدمرة بشكل نهائي من الجسم.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "المحافظة على النتائج على المدى الطويل",
                    "desc": "يمكن أن تدوم النتائج لفترة طويلة مع اتباع نظام غذائي صحي وممارسة الرياضة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح العناية بعد العلاج",
            "subheading": "تُعد إرشادات العناية بعد جلسة تجميد الدهون هامة جدًا",
            "para": "رغم أن إجراء تجميد الدهون غير جراحي ولا يتطلب فترة نقاهة طويلة، إلا أن اتباع بعض الإرشادات بعد الجلسة يمكن أن يُحدث فرقًا كبيرًا في سرعة التعافي وفعالية النتائج.",
            "items": [
                {
                    "title": "حافظ على ترطيب الجسم",
                    "desc": "اشرب كميات وفيرة من الماء لمساعدة الجسم على التخلص من الخلايا الدهنية التالفة، حيث يعزز الترطيب الجيد الصحة العامة ويسرع عملية الشفاء.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "مارس التمارين الخفيفة",
                    "desc": "يساعد القيام بنشاطات بسيطة مثل المشي أو تمارين الإطالة على تنشيط الدورة الدموية ودعم الجهاز اللمفاوي في طرد الدهون التالفة.",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "تجنب التمارين الشاقة",
                    "desc": "تجنب التمارين القوية أو أي مجهود قد يسبب إزعاجًا للمنطقة المعالجة خلال أول 24 إلى 48 ساعة بعد الجلسة. يمكنك بعد ذلك العودة تدريجيًا إلى روتينك المعتاد.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "ارتدِ ملابس مريحة",
                    "desc": "قد تشعر ببعض التورم أو التحسس في المنطقة المعالجة، لذا يُنصح بارتداء ملابس فضفاضة ومريحة لتقليل الاحتكاك والالتهاب.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "دلك المنطقة المعالجة",
                    "desc": "يساعد تدليك المنطقة لمدة 5 إلى 10 دقائق مرتين يوميًا على تفكيك الخلايا الدهنية وتنشيط الدورة الدموية، مما يعزز فاعلية النتائج.",
                    "icon": "fa-solid fa-hands"
                },
                {
                    "title": "اتبع نظامًا غذائيًا صحيًا",
                    "desc": "تناول وجبات متوازنة لدعم نتائج حرق الدهون، وتجنب الأطعمة الغنية بالدهون أو السكر، لأنها قد تبطئ من تقدم العلاج.",
                    "icon": "fa-solid fa-apple-alt"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم عدد الجلسات التي سأحتاجها؟",
                    "answer": "معظم المرضى يحققون النتائج المرجوة بعد 1-2 جلسة لكل منطقة علاجية، مع تباعد بضعة أشهر بينها."
                },
                {
                    "question": "هل تجميد الدهون مؤلم؟",
                    "answer": "يُتحمل الإجراء بشكل عام جيدًا. قد تشعر ببرودة شديدة في البداية، لكن هذا الإحساس عادة ما يهدأ مع تخدير المنطقة."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "قد تبدأ بملاحظة النتائج خلال 3 أسابيع، مع ظهور النتائج المثلى بعد 2-3 أشهر حيث يتخلص جسمك بشكل طبيعي من الخلايا الدهنية."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "تشمل الآثار الجانبية المؤقتة الشائعة الاحمرار والتورم والكدمات والخدر أو الوخز في المنطقة المعالجة، والتي تختفي عادة في غضون أيام أو أسابيع."
                },
                {
                    "question": "هل تقليل الدهون دائم؟",
                    "answer": "نعم، يتم التخلص من الخلايا الدهنية المدمرة بشكل دائم. ومع ذلك، من المهم الحفاظ على وزن ثابت لمنع الخلايا الدهنية المتبقية من التضخم."
                },
                {
                    "question": "من ليس مرشحًا جيدًا؟",
                    "answer": "لا يناسب تجميد الدهون الأشخاص المصابين بالسمنة أو أولئك الذين يعانون من برودة الدم الانتيابية أو أمراض التجلط البارد أو الهيموغلوبينية الباردة الانتيابية."
                }
            ]
        },
        "treatmentAreas1": [

        ],
        "treatmentAreas2": [

        ]
    }
}